// extracted by mini-css-extract-plugin
module.exports = {"box":"TweetBar_box__2RF4D","textBox":"TweetBar_textBox__3__RJ","btn":"TweetBar_btn__2nI9s","d-flex":"TweetBar_d-flex__2K94N"};